<div id="new-device-wrapper" data-cy="new-device-wrapper">
  <ep-device-form-card
    mode="add"
    [isSaving]="isSaving"
    [isSaveDisabled]="(isSaveDisabled$ | async) === true || !locations.length"
    (save)="saveDevice()"
  >
    <app-device-form></app-device-form>
  </ep-device-form-card>
</div>
